videojs.addLanguage('gd', {
  "Audio Player": "Cluicheadair fuaime",
  "Video Player": "Cluicheadair video",
  "Play": "Cluich",
  "Pause": "Cuir ’na stad",
  "Replay": "Cluich a-rithist",
  "Current Time": "An ùine làithreach",
  "Duration": "Faide",
  "Remaining Time": "An ùine air fhàgail",
  "Stream Type": "Seòrsa an t-sruthaidh",
  "LIVE": "BEÒ",
  "Seek to live, currently behind live": "A’ sireadh sruth beò ’s air dheireadh",
  "Seek to live, currently playing live": "A’ sireadh sruth beò ’s ‘ga chluich",
  "Loaded": "Air a luchdadh",
  "Progress": "Adhartas",
  "Progress Bar": "Bàr adhartais",
  "progress bar timing: currentTime={1} duration={2}": "{1} à {2}",
  "Fullscreen": "Làn-sgrìn",
  "Non-Fullscreen": "Fàg modh làn-sgrìn",
  "Mute": "Mùch",
  "Unmute": "Dì-mhùch",
  "Playback Rate": "Reat na cluiche",
  "Subtitles": "Fo-thiotalan",
  "subtitles off": "fo-thiotalan dheth",
  "Captions": "Caipseanan",
  "captions off": "caipseanan dheth",
  "Chapters": "Caibideil",
  "Descriptions": "Tuairisgeulan",
  "descriptions off": "tuairisgeulan dheth",
  "Audio Track": "Traca fuaime",
  "Volume Level": "Àirde na fuaime",
  "You aborted the media playback": "Sguir thu de chluich a’ mheadhain",
  "A network error caused the media download to fail part-way.": "Cha deach leinn an còrr dhen mheadhan a luchdadh a-nuas ri linn mearachd lìonraidh.",
  "The media could not be loaded, either because the server or network failed or because the format is not supported.": "Cha b’ urrainn dhuinn am meadhan a luchdadh – dh’fhaoidte gun do dh’fhàillig leis an fhrithealaiche no an lìonra no nach cuir sinn taic ris an fhòrmat.",
  "The media playback was aborted due to a corruption problem or because the media used features your browser did not support.": "Sguir sinn de chluich a’ mheadhain – dh’fhaoidte gu bheil e coirbte no gu bheil gleus aig a’ mheadhan nach cuir am brabhsair taic ris.",
  "No compatible source was found for this media.": "Cha ceach tùs co-chòrdail a lorg airson a’ mheadhain seo.",
  "The media is encrypted and we do not have the keys to decrypt it.": "Tha am meadhan crioptaichte ’s chan eil iuchair dì-chrioptachaidh againn dha.",
  "Play Video": "Cluich video",
  "Close": "Dùin",
  "Close Modal Dialog": "Dùin an còmhradh",
  "Modal Window": "Uinneag mòdach",
  "This is a modal window": "Seo uinneag mòdach",
  "This modal can be closed by pressing the Escape key or activating the close button.": "’S urrainn dhut seo a dhùnadh leis an iuchair Escape no leis a’ phutan dùnaidh.",
  ", opens captions settings dialog": ", fosglaidh e còmhradh nan roghainnean",
  ", opens subtitles settings dialog": ", fosglaidh e còmhradh nam fo-thiotalan",
  ", opens descriptions settings dialog": ", fosglaidh e còmhradh roghainnean nan tuairisgeulan",
  ", selected": ", air a thaghadh",
  "captions settings": "roghainnean nan caipseanan",
  "subtitles settings": "roghainnean nam fo-thiotalan",
  "descriptions settings": "roghainnean nan tuairisgeulan",
  "Text": "Teacsa",
  "White": "Geal",
  "Black": "Dubh",
  "Red": "Dearg",
  "Green": "Uaine",
  "Blue": "Gorm",
  "Yellow": "Buidhe",
  "Magenta": "Magenta",
  "Cyan": "Saidhean",
  "Background": "Cùlaibh",
  "Window": "Uinneag",
  "Transparent": "Trìd-shoilleir",
  "Semi-Transparent": "Leth-thrìd-shoilleir",
  "Opaque": "Trìd-dhoilleir",
  "Font Size": "Meud a’ chrutha-chlò",
  "Text Edge Style": "Stoidhle oir an teacsa",
  "None": "Chan eil gin",
  "Raised": "Àrdaichte",
  "Depressed": "Air a bhrùthadh",
  "Uniform": "Cunbhalach",
  "Dropshadow": "Sgàil",
  "Font Family": "Teaghlach a’ chrutha-chlò",
  "Proportional Sans-Serif": "Sans-serif co-rèireach",
  "Monospace Sans-Serif": "Sans-serif aon-leud",
  "Proportional Serif": "Serif co-rèireach",
  "Monospace Serif": "Serif aon-leud",
  "Casual": "Fuasgailte",
  "Script": "Sgriobt",
  "Small Caps": "Ceann-litrichean beaga",
  "Reset": "Ath-shuidhich",
  "restore all settings to the default values": "till dhan a h-uile bun-roghainn",
  "Done": "Deiseil",
  "Caption Settings Dialog": "Còmhradh roghainnean nan caipseanan",
  "Beginning of dialog window. Escape will cancel and close the window.": "Toiseach uinneag còmhraidh. Sguiridh Escape dheth ’s dùinidh e an uinneag",
  "End of dialog window.": "Deireadh uinneag còmhraidh.",
  "{1} is loading.": "Tha {1} ’ga luchdadh."
});